import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Telemetry } from '@videoblocks/kafka-rest-client';
import { LegacyPrimaryButton as PrimaryButton } from '@videoblocks/storywind';

import { notify } from '../../ReactToastify/containers/ReactToastifyContainer';
import ModalDialog from '../../app/Shared/ModalDialog';
import { hidePopUp } from '../actions/PopUpsActions';
import { selectPopUpIsOpen } from '../selectors/PopUpsSelectors';
import { SHARE_FOLDER_MODAL } from './types';

type Props = {
  shareUrl: string;
  folderUniqueId: string;
};

const ShareFolderModal = ({ shareUrl, folderUniqueId }: Props) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectPopUpIsOpen(SHARE_FOLDER_MODAL));
  const textAreaRef = React.useRef<HTMLTextAreaElement>();

  const handleCloseModal = () => {
    dispatch(hidePopUp());
  };

  const copyLinkHandler = () => {
    Telemetry.increment('folders.share');

    textAreaRef.current.value = shareUrl;
    textAreaRef.current.select();

    document.execCommand('copy');
    notify('Folder link copied to clipboard');
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      contentLabel="Send link to view folder"
      onRequestClose={handleCloseModal}
      className="max-w-2xl"
    >
      <p>
        Share this folder with clients and teammates for feedback by sending
        them the link below.
      </p>

      <div className="relative h-10">
        <textarea
          key={'shareLink' + folderUniqueId}
          readOnly={true}
          defaultValue={shareUrl}
          className="shareFolderPopUp-link w-full h-10 leading-10 border-gray-400 rounded pl-1 text-gray-700 text-sm"
          ref={textAreaRef}
        />

        <div
          role="button"
          tabIndex={0}
          className="shareFolderPopUp-copyLinkButton absolute h-10 w-14 right-0 top-0 rounded-r bg-gray-800"
          onClick={copyLinkHandler}
          onKeyDown={copyLinkHandler}
        >
          <img
            src={`${__ASSETS_COMMON_IMAGES_URL__}/member/folders/copy-white.svg`}
            title="Copy Link"
            alt="Copy Link"
            className="shareFolderPopUp-copyLinkIcon mt-1 ml-3 h-7"
            width={28}
            height={28}
          />
        </div>
      </div>

      <div className="mt-8 text-center">
        <PrimaryButton onClick={handleCloseModal}>Done</PrimaryButton>
      </div>
    </ModalDialog>
  );
};

export default ShareFolderModal;
